import type { ReactElement } from "react";
import { tv } from "tailwind-variants";

import { focusRing, icons } from "@/ui";

const moreMenuTabVariants = tv({
  slots: {
    button: [
      "flex w-full cursor-pointer items-center justify-between gap-4 border-b border-b-line px-3 py-4 text-left",
      "transition-colors hover:bg-surface-hover",
      focusRing,
      "sm:rounded-card sm:border-b-0",
    ],
    iconWrapper: "flex size-9 shrink-0 items-center justify-center rounded-full transition-colors",
    chevron: "size-5 shrink-0 stroke-content-muted",
  },
  variants: {
    active: {
      true: {
        button: "bg-surface-sunken font-semibold hover:bg-surface-sunken",
        iconWrapper: "bg-surface-inverted text-content-on-inverted",
      },
      false: {
        iconWrapper: "bg-surface-sunken text-content",
      },
    },
  },
});

const { button, chevron, iconWrapper } = moreMenuTabVariants();

type MoreMenuTabProps = {
  text: string;
  icon?: ReactElement;
  active?: boolean;
  onClick?: () => void;
};

export const MoreMenuTab = ({ active = false, icon, onClick, text }: MoreMenuTabProps) => {
  return (
    <button
      aria-current={active || undefined}
      className={button({ active })}
      onClick={onClick}
      type="button"
    >
      <span aria-hidden="true" className={iconWrapper({ active })}>
        {icon}
      </span>

      <span className="grow">{text}</span>

      <icons.ChevronRightIcon aria-hidden="true" className={chevron()} />
    </button>
  );
};
